// COPIED FILE - do not edit here.
// Master: _shared/ at the top level. Change it there, then run
// `node sync-shared.mjs`, or services will silently disagree about
// permissions and token formats.

/**
 * The ONE place branding lives. Every service and the frontend import from here.
 * Changing the company URL or product name is a one-line edit, everywhere at once.
 */
export const BRAND = {
  company: "Py Digital Solution",
  companyUrl: "https://pydigitalsolution.me",
  product: "Py Mail",
  tagline: "Business email, without the server room",
} as const;
